export default "__VITE_ASSET__0613f18e__"